export default class SaveStaffRequest {
  id: number = 0;
  officeId: number = 0;
  roleId: number = 0;
  workTypeIds: number[] = [];
  name: string = "";
  tel: string = "";
  email: string = "";
  hasRole: boolean = false;
  isWorker: boolean = false;
  isHiddenInfo: number = 0;
  isInternal: boolean = false;
  userId: number = 0;
  hasTaskSub: boolean = false;
}
